/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GiftIcon = ({ width = 24, height = 24, hidden = false, title = 'Gift' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 33a1 1 0 0 0 1 1h13V20H2ZM0 13v4a1 1 0 0 0 1 1h15v-6H1a1 1 0 0 0-1 1Zm20 21h13a1 1 0 0 0 1-1V20H20Zm15-22H20v6h15a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM26 2c-1.81 0-5.638 1.39-8 5.172C15.638 3.39 11.81 2 10 2a4 4 0 0 0 0 8h16a4 4 0 0 0 0-8ZM10 8a2 2 0 0 1 0-4 8.734 8.734 0 0 1 6.2 4Zm16 0h-6.2A8.734 8.734 0 0 1 26 4a2 2 0 0 1 0 4Z"
    />
  </svg>`;
};
